<template>
    <v-layout>
       <v-flex class="check-container--label">
        <div v-if="filterItem && filterItem.label && filterItem.subFilters" class="secondary-filter-options ">
            <div class="pointer"
                 :data-qe-id="`member-directory_${parentFilterKey}_filter-with-secondary_options-${filterIndex}`"
                 @click.prevent="handleSelectedSubFilter(filterItem)" >
                <label  v-if="(!isSelectedSubFilter && !hasSelectedSubFilterInState)"
                       class="check-container ypo_blue_color">
                    <span>{{filterItem.label}}</span>
                    <input type="checkbox"
                           :data-qe-id="`member-directory_${parentFilterKey}_filter-with-secondary_options_checkbox_${filterIndex}`">
                    <span class="checkmark"></span>
                </label>
                <div v-if="isSelectedSubFilter || hasSelectedSubFilterInState">
                    <v-icon color="ypo_cta" size="24" class="plus_icon">add_circle</v-icon>
                    <span class="selected-label bold-font">{{filterItem.label}}</span>
                </div>
            </div>
        </div>
       </v-flex>
    </v-layout>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex';
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";

    export default {
        name: 'FilterWithSecondaryOptions',
        props: {
            filterItem: {
                type: Object,
                required: true,
            },
            filterIndex: {
                type: Number,
                required: true,
            },
            parentFilterKey: {
                type: String,
                default: '',
                required: true,
            },
            isPreviouslySelected: {
                type: Function,
                required: true,
            },
        },
        methods: {
            ...mapMutations({
                setSelectedSubFilter: `memberDirectory/${storeMutation.setSelectedSubFilter}`,
                setSubFilterList: `memberDirectory/${storeMutation.setSubFilterList}`,
            }),
            handleSelectedSubFilter(filter) {
                this.setSubFilterList(filter);
                const activeSubFilter =
                    this.subFilterList.find(item => item.key.toLowerCase() === filter.filterKey.toLowerCase() && item.value.toLowerCase() === filter.filterValue.toLowerCase());
                if (activeSubFilter && activeSubFilter.isActive) {
                    this.setSelectedSubFilter({ ...activeSubFilter, subFilters: this.filterItem.subFilters });
                } else {
                    this.setSelectedSubFilter(null);
                }
            },
        },
        computed: {
            ...mapGetters({
                ribbonState: `memberDirectory/${storeGetters.ribbonState}`,
                selectedSubFilter: `memberDirectory/${storeGetters.selectedSubFilter}`,
                subFilterList: `memberDirectory/${storeGetters.subFilterList}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
            }),
            isSelectedSubFilter() {
                const { subFilterList, selectedSubFilter } = this;
                let isSelected = false;
                if (selectedSubFilter
                    && this.filterItem && this.filterItem.filterKey
                    && this.filterItem.filterKey === selectedSubFilter.key
                    && this.filterItem.filterValue === selectedSubFilter.value
                    && subFilterList) {
                    const activeItem =
                        subFilterList.find(item => item.key.toLowerCase() === selectedSubFilter.key.toLowerCase() && item.value.toLowerCase() === selectedSubFilter.value.toLowerCase());
                    if (activeItem) {
                        isSelected = activeItem.isActive;
                    }
                }
                return isSelected;
            },
            hasSelectedSubFilterInState() {
                const {
                    filterItem,
                    ribbonState,
                    parentFilterKey,
                } = this;
                let hasSelected = false;
                if (filterItem && filterItem.subFilters
                    && ribbonState && parentFilterKey && ribbonState.hasOwnProperty(parentFilterKey)) {
                    hasSelected = filterItem.subFilters
                        .some(item => ribbonState[parentFilterKey].includes(ribbonState[parentFilterKey]
                            .find(it => it.filterKey === item.filterKey && it.filterValue === item.filterValue)));
                }
                return hasSelected;
            },
            hasChildrenSelected() {
                let isDisabled = false;
                if (this.ribbonState && this.filterItem) {
                    const itemsInState = this.ribbonState[this.parentFilterKey]
                        .filter(item => item.filterKey.toLowerCase() === this.filterItem.filterKey.toLowerCase()
                            && item.filterValue.includes(this.filterItem.label));
                    isDisabled = itemsInState.length > 1;
                }
                return isDisabled;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';

    .secondary-filter-options {
        @extend %ypo_checkbox;

        .selected-label {
            color: $ypo-blue;
            position: relative;
            font-size: 14px;
            margin-left: 10px;
        }

        .plus_icon {
            margin-left: -5px;
        }

        .blocked-filter {
            position: absolute;
            height: 100%;
            width: 100%;
            z-index: 2;
            top: 0;
            left: -2px;
            background-color: transparent;
        }
    }

</style>

<style lang="scss">
    @import '../../../common/styles/_colors.scss';

    .secondary-filter-options {
        .v-input--is-label-active {
            .v-input__slot {
                .v-label {
                    font-weight: 600 !important;
                }
            }
        }
    }
</style>
